var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRobinhood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2500,
    height: 2500,
    viewBox: "0 0 2500 2500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22315_577)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1250 2500C1940.36 2500 2500 1940.36 2500 1250C2500 559.644 1940.36 0 1250 0C559.644 0 0 559.644 0 1250C0 1940.36 559.644 2500 1250 2500Z",
    fill: "#CCFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1426.31 838.741H1139.76C1129.39 838.741 1120.63 842.888 1113.37 851.937L907.888 1106.43C877.725 1144.14 870.184 1179.01 870.184 1228.97V1489.12C803.261 1676.69 760.845 1803.94 729.74 1918.94C727.855 1926.29 730.683 1930.25 737.281 1930.25H768.386C774.041 1930.25 779.697 1927.42 781.582 1922.71C1016.28 1325.11 1271.72 1029.14 1431.96 851.937C1438.56 844.396 1435.73 838.741 1426.31 838.741Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1434.79 545.598C1415.56 553.044 1397.09 565.675 1388.6 572.933C1303.77 645.512 1247.22 703.009 1193.49 759.564C1186.89 766.162 1189.72 772.76 1199.14 772.76H1516.79C1546.01 772.76 1562.98 789.726 1562.98 818.946V1177.13C1562.98 1186.55 1570.52 1189.38 1576.18 1180.9L1767.52 931.113C1798.63 890.582 1808.05 878.329 1816.53 821.774C1827.85 738.827 1821.25 611.579 1771.29 558.794C1726.99 511.665 1527.16 509.78 1434.79 545.598Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1482.86 910.377C1285.86 1130 1132.22 1360.93 989.891 1638.99C986.309 1645.97 990.834 1652.19 999.317 1649.36L1293.4 1558.87C1326.58 1548.69 1345.24 1535.31 1361.27 1508.92L1492.29 1293.06C1495.11 1287.41 1496.06 1280.81 1496.06 1276.1V916.033C1496.06 906.607 1489.46 902.837 1482.86 910.377Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22315_577"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2500,
    height: 2500,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobinhood);
export default __webpack_public_path__ + "static/media/robinhood.697d67a6804035a7471404d7cd53c9b4.svg";
export { ForwardRef as ReactComponent };